require('./lbaKeyValuePairs.scss');

const $inject = [];

const lbaKeyValuePairs = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaKeyValuePairsCtrl',
    controllerAs: 'vm',
    template: require('./lbaKeyValuePairs.html')
  }
};

lbaKeyValuePairs.$inject = $inject;

export default lbaKeyValuePairs;



// WEBPACK FOOTER //
// ./src/components/lbaKeyValuePair/lbaKeyValuePairsDir.js